export default "__VITE_ASSET__B27wpW9R__ 100w";